// extracted by mini-css-extract-plugin
module.exports = {"title":"ColumnHeader_title__4kBUU","header":"ColumnHeader_header__15ts2","fixed":"ColumnHeader_fixed__1Z-35"};